import { useEffect, useRef } from "react"
import { toaster } from "components/common/Toast"
import { useJsApiLoader } from "@react-google-maps/api"

import { API_OPTIONS } from "constants/map"
import { useTranslation } from "react-i18next"

export default function useGeocoder() {
  const { isLoaded } = useJsApiLoader(API_OPTIONS)
  const geocoderRef = useRef(null)
  const t = useTranslation()

  const geocoder = (options, cb) => {
    // Guard: avoid calling geocode before Google Geocoder is initialized
    if (!geocoderRef.current) {
      toaster.error(t("addresses.google_maps_not_loaded", "Google Maps is not loaded yet."))
      if (typeof cb === "function") cb(null)
      return
    }
    geocoderRef.current.geocode(options, (result, status) => {
      if (status === window.google.maps.GeocoderStatus.OK) {
        if (!result.length) return cb(null)
        const [place] = result
        if (typeof cb === "function") cb(place)
      } else {
        toaster.error(t("addresses.geocode_error", { status }))
        if (typeof cb === "function") cb(null)
      }
    })
  }

  useEffect(() => {
    if (isLoaded && !geocoderRef.current) geocoderRef.current = new window.google.maps.Geocoder()
  }, [isLoaded])

  return geocoder
}
